import { Routes, Route } from 'react-router-dom';
import AjudaAC from '../pages/ajuda/ac';
import AjudaAR from '../pages/ajuda/ar';
import Outras from '../pages/ajuda/outras';
import AcAtendimento from '../pages/ac/index';
import ArAtendimento from '../pages/ar/arAtendimento';
import OutrasAtendimento from '../pages/outras/outrasAtendimento';
import OutrasPendencia from '../pages/outras/outrasPendencia';
import ArPendencia from '../pages/ar/arPendencia';
import AcPendencia from '../pages/ac/acPendencia';
import AcConcluido from "../pages/ac/acConcluido";
import ArConcluido from "../pages/ar/arConcluido";
import OutrasConcluido from "../pages/outras/outrasConcluido";

export default function Rotas(){
    return (
            <Routes>
              <Route path="/" element={<AcAtendimento />} />
              <Route path="/ac-pendencia" element={<AcPendencia />} />
              <Route path="/ac-concluido" element={<AcConcluido />} />
              <Route path="/ar-atendimento" element={<ArAtendimento />} />
              <Route path="/ar-pendencia" element={<ArPendencia />} />
              <Route path="/ar-concluido" element={<ArConcluido />} />
              <Route path="/outras-atendimento" element={<OutrasAtendimento />} />
              <Route path="/outras-pendencia" element={<OutrasPendencia />} />
              <Route path="/outras-concluido" element={<OutrasConcluido />} />
              <Route path="/ajuda/ac" element={<AjudaAC />} />
              <Route path="/ajuda/ar" element={<AjudaAR />} />
              <Route path="/ajuda/outras" element={<Outras />} />
            </Routes>
      );
}